/*
 * NextGenn engine · complete the routine (sections/ngs-routine.liquid).
 *
 * THE LINE DESCRIBES THE BAG, NOT THE TICKS. The shop's discount is decided by
 * how many bottles are in the bag — three is ten per cent, five is fifteen, and
 * both rules run automatically on the shop itself — so a line that counted only
 * what this block adds would say "five bottles" over the price of four. The
 * bottle on the page is counted, its price is in the sum, and on the tap the
 * block reads the bag and puts it in only if it is not there yet.
 *
 * It prints the sum rather than the word "save". A block that says "bundle and
 * save" without a number is asking to be believed; one that shows the
 * arithmetic is only telling you.
 */
if (!customElements.get('ngs-routine')) {
  customElements.define(
    'ngs-routine',
    class NGSRoutine extends HTMLElement {
      connectedCallback() {
        this.ticks = Array.prototype.slice.call(this.querySelectorAll('.ngs-routine__tick'));
        this.sum = this.querySelector('[data-ngs-sum]');
        this.button = this.querySelector('[data-ngs-add]');
        if (!this.ticks.length || !this.button) return;

        this.three = Number(this.dataset.three) || 0;
        this.five = Number(this.dataset.five) || 0;
        this.herePrice = Number(this.dataset.herePrice) || 0;
        this.said = this.button.textContent;

        this.onChange = this.reckon.bind(this);
        this.onAdd = this.add.bind(this);
        this.ticks.forEach(function (tick) { tick.addEventListener('change', this.onChange); }.bind(this));
        this.button.addEventListener('click', this.onAdd);
        this.reckon();
      }

      disconnectedCallback() {
        this.ticks.forEach(function (tick) { tick.removeEventListener('change', this.onChange); }.bind(this));
        if (this.button) this.button.removeEventListener('click', this.onAdd);
      }

      money(cents) {
        var whole = Math.round(cents / 100);
        return '$' + whole;
      }

      /* Whatever the shopper has actually chosen up the page — the SPF is sold
         in three shades and they are not the same variant. Dawn keeps the
         chosen one in the main form's hidden id, so read it there and fall
         back to the one the page was built with. */
      here() {
        var form = document.querySelector('product-form form [name="id"], form[action*="/cart/add"] [name="id"]');
        var chosen = form && form.value;
        return String(chosen || this.dataset.hereVariant || '');
      }

      reckon() {
        var on = this.ticks.filter(function (t) { return t.checked; });
        var pennies = on.reduce(function (total, t) { return total + (Number(t.dataset.price) || 0); }, 0);
        /* the bottle on this page is part of the bag, so it is part of both */
        var bottles = on.length + 1;
        var was = pennies + this.herePrice;
        var off = bottles >= 5 ? this.five : bottles >= 3 ? this.three : 0;

        this.button.disabled = on.length === 0;
        if (!on.length) {
          this.sum.textContent = this.dataset.none || '';
          return;
        }
        var now = Math.round(was * (100 - off) / 100);
        var line = (this.dataset.line || '')
          .replace('[n]', String(bottles))
          .replace('[was]', this.money(was))
          .replace('[now]', this.money(now))
          .replace('[off]', off + '%');
        /* no discount yet: say what is true rather than printing "0% off" */
        this.sum.textContent = off ? line : String(bottles) + ' bottles · ' + this.money(was);
      }

      add() {
        var on = this.ticks.filter(function (t) { return t.checked; });
        if (!on.length || !window.NGSCart) return;
        this.button.disabled = true;
        this.button.textContent = '…';

        var items = on.map(function (t) { return { id: t.dataset.variant, quantity: 1 }; });
        var mine = this.here();
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        /* The bag decides the discount, so the bottle on the page has to be in
           it — but only once. A bag we cannot read is not a reason to refuse
           the whole tap: add what was ticked and leave this bottle to the
           button above, which is where they would have added it anyway. */
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (bag) {
            var already = (bag.items || []).some(function (line) { return String(line.id) === mine; });
            return already ? items : [{ id: mine, quantity: 1 }].concat(items);
          })
          .catch(function () { return items; })
          .then(
            function (lines) {
              return window.NGSCart.add(lines);
            }.bind(this)
          )
          .catch(
            function () {
              this.button.disabled = false;
              this.button.textContent = this.said;
              if (this.sum) this.sum.textContent = this.dataset.error || '';
            }.bind(this)
          );
      }
    }
  );
}
